export const minioServer = "https://file.yumawk.com/ymoa/"
export const apiServer = "https://oa.server.yumawk.com/"

 // export const minioServer = "http://10.10.10.25:9000/ymoa/"
 // export const apiServer = "http://10.10.10.66:9090/"

// export const minioServer = "http://192.168.20.25:9000/ymoa/"
// export const apiServer = "https://192.168.20.7:9456/"

export function isNum(number) {
    var numReg = new RegExp('^[-\\+]?([0-9]+\\.?)?[0-9]+$')
    var numRe = new RegExp(numReg)
    if (numRe.test(number)) {
        return true;
    } else {
        return false
    }
}

export function digitUppercase(n = 0) {
    if (!isNum(n)) {
        return "零元整"
    }
    var fraction = ['角', '分'];
    var digit = [
        '零', '壹', '贰', '叁', '肆',
        '伍', '陆', '柒', '捌', '玖'
    ];
    var unit = [
        ['元', '万', '亿'],
        ['', '拾', '佰', '仟']
    ];
    var head = n < 0 ? '欠' : '';
    n = Math.abs(n);
    var s = '';
    for (var i = 0; i < fraction.length; i++) {
        s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '');
    }
    s = s || '整';
    n = Math.floor(n);
    for (var i = 0; i < unit[0].length && n > 0; i++) {
        var p = '';
        for (var j = 0; j < unit[1].length && n > 0; j++) {
            p = digit[n % 10] + unit[1][j] + p;
            n = Math.floor(n / 10);
        }
        s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
    }
    return head + s.replace(/(零.)*零元/, '元')
        .replace(/(零.)+/g, '零')
        .replace(/^整$/, '零元整');
};

export function uuid() {
    function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }

    return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
    //return (S4()+S4()+S4()+S4()+S4()+S4()+S4()+S4());
}

export function getUrlParams(parameName) {
    // 获取url中跟在问号后面的部分
    var parames = window.location.search;
    //  检测参数是否存在
    if (parames.indexOf(parameName) > -1) {
        var parameValue = ''
        parameValue = parames.substring(parames.indexOf(parameName), parames.length)
        // 检测后面是否还有参数
        if (parameValue.indexOf('&') > -1) {
            // 去除后面多余的参数, 得到最终 parameName=parameValue 形式的值
            parameValue = parameValue.substring(0, parameValue.indexOf('&'))
            // 去掉参数名, 得到最终纯值字符串
            parameValue = parameValue.replace(parameName + '=', '')
            return parameValue
        }
        return ''
    }
}

import CryptoJS from 'crypto-js';

const key = CryptoJS.enc.Hex.parse("ECDE992F8C8BE08C3215880DBB77E90B");

/**
 * Aes加密
 */
export function AesEncrypt(orgData) {
    let data = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(orgData), key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    return data.ciphertext.toString();
}

/**
 * Aes解密
 * @return {string}
 */
export function AesDecrypt(encryptData) {
    let data = CryptoJS.AES.decrypt(CryptoJS.enc.Base64.stringify(CryptoJS.enc.Hex.parse(encryptData)), key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    return CryptoJS.enc.Utf8.stringify(data).toString();
}

export function IsPdf(fileName) {
    if (!fileName) {
        return false
    }
    let arr = fileName.split(".")
    return arr[arr.length - 1] === "pdf"
}
